import axios from "axios";
import routes from "../../configs/api";

const verifyOTP = (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.VERIFY_OTP;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default verifyOTP;
